import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEventsTicketingTicketManagementUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'events._base_domain_': [
      {
        srcPath: '',
        destPath: '',
      },
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
    ],
    'www.wixevents.com': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/api',
        destPath: '/api',
      },
      {
        srcPath: '/viewEvent',
        destPath: '/viewEvent',
      },
      {
        srcPath: '/viewRsvpDashboard',
        destPath: '/viewRsvpDashboard',
      },
      {
        srcPath: '/viewOrderDashboard',
        destPath: '/viewOrderDashboard',
      },
      {
        srcPath: '/viewSummarySubscription',
        destPath: '/viewSummarySubscription',
      },
      {
        srcPath: '/check-in',
        destPath: '/check-in',
      },
      {
        srcPath: '/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/export',
        destPath: '/export',
      },
      {
        srcPath: '/tickets',
        destPath: '/tickets',
      },
      {
        srcPath: '/payment-redirect',
        destPath: '/payment-redirect',
      },
      {
        srcPath: '/admin',
        destPath: '/admin',
      },
      {
        srcPath: '/ticket',
        destPath: '/ticket',
      },
      {
        srcPath: '/media',
        destPath: '/media',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/wix-events-web',
        destPath: '',
      },
    ],
    'events.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/events',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/events',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
      {
        srcPath: '/events/v1/reports',
        destPath: '/v1/reports',
      },
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/web',
        destPath: '/v1/web',
      },
      {
        srcPath: '/events/v2/tickets',
        destPath: '/v2/tickets',
      },
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/events/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    _: [
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_events_tickets';

/**
 * Retrieves a list of up to 100 tickets.
 *
 * <!--
 * >**Note:** This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 */
export function listTickets(payload: object): RequestOptionsFactory<any> {
  function __listTickets({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.ListTickets',
      packageName: PACKAGE_NAME,
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/events/{eventId}/tickets',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
      fallback: [
        {
          method: 'GET' as any,
          url: resolveWixEventsTicketingTicketManagementUrl({
            protoPath: '/v1/events/{eventId}/tickets',
            data: payload,
            host,
          }),
          params: toURLSearchParams(payload),
        },
      ],
    };

    return metadata;
  }

  return __listTickets;
}

/** Retrieves a ticket by the unique ticket number. */
export function getTicket(payload: object): RequestOptionsFactory<any> {
  function __getTicket({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.GetTicket',
      packageName: PACKAGE_NAME,
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/events/{eventId}/tickets/{ticketNumber}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'ticket.checkIn.created' },
              { path: 'ticket.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'ticket.guestDetails.form.inputValues.number' },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getTicket;
}

/** Checks in 1 or more tickets. */
export function checkInTicket(payload: object): RequestOptionsFactory<any> {
  function __checkInTicket({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.CheckInTicket',
      packageName: PACKAGE_NAME,
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets/check-in',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __checkInTicket;
}

/** Deletes check-ins for 1 or more tickets. */
export function deleteTicketCheckIn(
  payload: object
): RequestOptionsFactory<any> {
  function __deleteTicketCheckIn({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'DELETE' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.DeleteTicketCheckIn',
      packageName: PACKAGE_NAME,
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets/check-in',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __deleteTicketCheckIn;
}

/** Updates a ticket. */
export function updateTicket(payload: object): RequestOptionsFactory<any> {
  function __updateTicket({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'checkoutForm.inputValues.number' },
          { path: 'checkoutForm.inputValues.address.address.geocode.latitude' },
          {
            path: 'checkoutForm.inputValues.address.address.geocode.longitude',
          },
          { path: 'guestDetails.form.inputValues.number' },
          {
            path: 'guestDetails.form.inputValues.address.address.geocode.latitude',
          },
          {
            path: 'guestDetails.form.inputValues.address.address.geocode.longitude',
          },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'checkoutForm.inputValues.dateTime' },
          { path: 'guestDetails.form.inputValues.dateTime' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.UpdateTicket',
      packageName: PACKAGE_NAME,
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/events/{eventId}/tickets/{ticketNumber}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'ticket.checkIn.created' },
              { path: 'ticket.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'ticket.guestDetails.form.inputValues.number' },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateTicket;
}

/** Archives multiple tickets. */
export function bulkUpdateTickets(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateTickets({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.BulkUpdateTickets',
      packageName: PACKAGE_NAME,
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/events/{eventId}/tickets',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateTickets;
}
